/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TokenPaymentMethod } from './TokenPaymentMethod';
import {
    TokenPaymentMethodFromJSON,
    TokenPaymentMethodFromJSONTyped,
    TokenPaymentMethodToJSON,
    TokenPaymentMethodToJSONTyped,
} from './TokenPaymentMethod';

/**
 * Used to save a fiat => Fuel purchase attempt.
 * @export
 * @interface FuelPurchase
 */
export interface FuelPurchase {
    /**
     * 
     * @type {string}
     * @memberof FuelPurchase
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof FuelPurchase
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof FuelPurchase
     */
    updatedAt: number;
    /**
     * 
     * @type {TokenPaymentMethod}
     * @memberof FuelPurchase
     */
    paymentMethod: TokenPaymentMethod;
    /**
     * 
     * @type {string}
     * @memberof FuelPurchase
     */
    user: string;
    /**
     * 
     * @type {number}
     * @memberof FuelPurchase
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof FuelPurchase
     */
    fiat: number;
    /**
     * 
     * @type {number}
     * @memberof FuelPurchase
     */
    fuel: number;
    /**
     * 
     * @type {number}
     * @memberof FuelPurchase
     */
    xp: number;
    /**
     * 
     * @type {number}
     * @memberof FuelPurchase
     */
    expiresAt: number;
    /**
     * 
     * @type {boolean}
     * @memberof FuelPurchase
     */
    isComplete: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FuelPurchase
     */
    isPending: boolean;
    /**
     * 
     * @type {string}
     * @memberof FuelPurchase
     */
    fuelTransaction?: string;
    /**
     * 
     * @type {string}
     * @memberof FuelPurchase
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof FuelPurchase
     */
    paymentIntentId?: string;
    /**
     * 
     * @type {string}
     * @memberof FuelPurchase
     */
    experienceRewardsTransaction?: string;
    /**
     * 
     * @type {string}
     * @memberof FuelPurchase
     */
    errorMessage?: string;
}



/**
 * Check if a given object implements the FuelPurchase interface.
 */
export function instanceOfFuelPurchase(value: object): value is FuelPurchase {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('fiat' in value) || value['fiat'] === undefined) return false;
    if (!('fuel' in value) || value['fuel'] === undefined) return false;
    if (!('xp' in value) || value['xp'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('isComplete' in value) || value['isComplete'] === undefined) return false;
    if (!('isPending' in value) || value['isPending'] === undefined) return false;
    return true;
}

export function FuelPurchaseFromJSON(json: any): FuelPurchase {
    return FuelPurchaseFromJSONTyped(json, false);
}

export function FuelPurchaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelPurchase {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'paymentMethod': TokenPaymentMethodFromJSON(json['paymentMethod']),
        'user': json['user'],
        'price': json['price'],
        'fiat': json['fiat'],
        'fuel': json['fuel'],
        'xp': json['xp'],
        'expiresAt': json['expiresAt'],
        'isComplete': json['isComplete'],
        'isPending': json['isPending'],
        'fuelTransaction': json['fuelTransaction'] == null ? undefined : json['fuelTransaction'],
        'paymentMethodId': json['paymentMethodId'] == null ? undefined : json['paymentMethodId'],
        'paymentIntentId': json['paymentIntentId'] == null ? undefined : json['paymentIntentId'],
        'experienceRewardsTransaction': json['experienceRewardsTransaction'] == null ? undefined : json['experienceRewardsTransaction'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function FuelPurchaseToJSON(json: any): FuelPurchase {
    return FuelPurchaseToJSONTyped(json, false);
}

export function FuelPurchaseToJSONTyped(value?: FuelPurchase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'paymentMethod': TokenPaymentMethodToJSON(value['paymentMethod']),
        'user': value['user'],
        'price': value['price'],
        'fiat': value['fiat'],
        'fuel': value['fuel'],
        'xp': value['xp'],
        'expiresAt': value['expiresAt'],
        'isComplete': value['isComplete'],
        'isPending': value['isPending'],
        'fuelTransaction': value['fuelTransaction'],
        'paymentMethodId': value['paymentMethodId'],
        'paymentIntentId': value['paymentIntentId'],
        'experienceRewardsTransaction': value['experienceRewardsTransaction'],
        'errorMessage': value['errorMessage'],
    };
}

